import { gql } from "@apollo/client";

export const GET_MCP_CONNECTION = gql`
  query mcpConnection {
    mcpConnection {
      endpoint
      tokens {
        id
        label
        token
        canWrite
        client
        expiresAt
        lastUsedAt
        createdAt
      }
    }
  }
`;

export const ISSUE_MCP_TOKEN = gql`
  mutation issueMcpToken($label: String, $allowChanges: Boolean) {
    issueMcpToken(label: $label, allowChanges: $allowChanges) {
      id
      label
      token
      canWrite
      client
      expiresAt
      lastUsedAt
      createdAt
    }
  }
`;

export const REVOKE_MCP_TOKEN = gql`
  mutation revokeMcpToken($id: String) {
    revokeMcpToken(id: $id) {
      answer
    }
  }
`;
